import React from 'react';

type StatusType =
  | 'auto-applied' |'under-review' |'shortlisted' |'interview' |'offer' |'rejected' |'active' |'expired' |'pending' |'verified';

const statusConfig: Record<
  StatusType,
  { label: string; bg: string; text: string; dot: string }
> = {
  'auto-applied': {
    label: 'Auto-Applied',
    bg: 'bg-blue-50',
    text: 'text-blue-700',
    dot: 'bg-blue-500',
  },
  'under-review': {
    label: 'Under Review',
    bg: 'bg-amber-50',
    text: 'text-amber-700',
    dot: 'bg-amber-500',
  },
  shortlisted: {
    label: 'Shortlisted',
    bg: 'bg-purple-50',
    text: 'text-purple-700',
    dot: 'bg-purple-500',
  },
  interview: {
    label: 'Interview',
    bg: 'bg-cyan-50',
    text: 'text-cyan-700',
    dot: 'bg-cyan-500',
  },
  offer: {
    label: 'Offer Extended',
    bg: 'bg-green-50',
    text: 'text-green-700',
    dot: 'bg-green-500',
  },
  rejected: {
    label: 'Not Suitable',
    bg: 'bg-red-50',
    text: 'text-red-600',
    dot: 'bg-red-400',
  },
  active: {
    label: 'Active',
    bg: 'bg-green-50',
    text: 'text-green-700',
    dot: 'bg-green-500',
  },
  expired: {
    label: 'Expired',
    bg: 'bg-red-50',
    text: 'text-red-600',
    dot: 'bg-red-400',
  },
  pending: {
    label: 'Pending',
    bg: 'bg-amber-50',
    text: 'text-amber-700',
    dot: 'bg-amber-500',
  },
  verified: {
    label: 'Verified',
    bg: 'bg-green-50',
    text: 'text-green-700',
    dot: 'bg-green-500',
  },
};

export default function StatusBadge({ status }: { status: StatusType }) {
  const config = statusConfig[status] || statusConfig['pending'];
  return (
    <span
      className={`status-badge ${config.bg} ${config.text}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${config.dot} mr-1.5`} />
      {config.label}
    </span>
  );
}